import axios from 'axios'
import { setModalState } from '../../../redux/store/Modal/Actions/actionsModal'
import { removeEventSuccessAction } from '../../../redux/store/EditEvent/actions'
import { clearLoading, setLoading } from '../../../redux/store/Loading/actions'
import { store } from '../../../redux/store/store'
import { api } from '../../api'

export const removeEventService = async (eventId: string) => {
  const { dispatch } = store
  try {
    dispatch(setLoading())
    await api
      .delete(`/api/backoffice/events/${eventId}`)
      .then(() => dispatch(removeEventSuccessAction(eventId)))
    dispatch(clearLoading())
  } catch (e) {
    dispatch(clearLoading())
    if (axios.isAxiosError(e)) {
      switch (e.response?.status) {
        case 500:
          dispatch(
            setModalState({
              open: true,
              buttonText: 'Tentar novamente',
              message: 'Erro interno do servidor',
              variant: 'error'
            })
          )
          break
        case 404:
          dispatch(
            setModalState({
              open: true,
              buttonText: 'Fechar',
              message: 'Evento não encontrado',
              variant: 'error'
            })
          )
          break
        default:
          break
      }
    } else {
      dispatch(
        setModalState({
          open: true,
          buttonText: 'Tentar novamente',
          message: 'Erro interno do servidor',
          variant: 'error'
        })
      )
    }
  }
}
